import { useFeatureFlags } from '@/contexts/FeatureFlagsContext';

export function useHasCustomEmailSignature() {
  const { flags } = useFeatureFlags();

  return !!flags.customEmailSignature;
}
